import { Select, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

const SelectTypeOrder = observer(() => {
  const { pageStore } = useStores();

  return (
    <VStack
    >
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        fontSize={"14px"}
        width={"250px"}
        value={pageStore.selected_view}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedView(selectedValue);
        }}
      >
        <option value="manager-lite" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Кратко</option>
        <option value="manager-deals" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Сделки</option>
        <option value="manager-orgs" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Организации</option>
        <option value="org-deals" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Организации — Сделки</option>
        <option value="manager-partner" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Менеджер — Контрагенты</option>
        <option value="partner-manager" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты — Менеджер</option>
        <option value="manager-partner-lite" style={{ background: "#0C0C0C", color: "#EEEEEE"}}>Менеджер - Контрагенты - Кратко </option>
        <option value="departament-manager" style={{ background: "#0C0C0C", color: "#EEEEEE"}}>ОП с РОПом</option>
        <option value="departament-manager-withoutROP" style={{ background: "#0C0C0C", color: "#EEEEEE"}}>ОП без РОПа</option>
        <option value="partner" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Контрагенты</option>
        <option value="deal" style={{ background: "#0C0C0C", color: "#EEEEEE" }}>Сделки</option>
      </Select>
    </VStack>
  );
});

export default SelectTypeOrder;
